export const PRODUCTS_CHANGED = 'product-bundle.products-changed';
export const ADD_TO_CART_ANALYTICS = 'bundle-mini.bipAddToCart';
export const BIP_TO_PIP_PRODUCT_VIEW = 'bundle-mini.viewBundleClick';
export const PRODUCT_BUNDLE_PRODUCT_LIST_ITEM_CLICK = 'product-bundle.productListItemClick';
export const PRODUCT_BUNDLE_ACCORDION_OPEN = 'product-bundle.open-accordion';
export const QUICK_VIEW_ANALYTICS = 'bundle-quick-view.openQuickView';
export const QUICK_VIEW_FROM_RECS_ANALYTICS = 'bundle-quick-view.openQuickViewFromRecs';
export const ACCESSORIES_CHANGED = 'product-bundle.accessories-changed';
export const UPDATE_PRICE_ADJUSTMENT = 'product-bundle.update-price-adjustment';
export const VARIANT_TYPE_CHANGED = 'product-bundle.variant-type-changed';